module.exports = __webpack_public_path__ + "img/icon1.29819f70.png";